export const GameTypes = {
    addition1to20: {
        type: 'TYPE_ADDITION',
        icon: '+',
        numberGenerator: {"type": "scale", "name": "1to20", "nr1": 1, "nr2": 20, "nr1r": 5, "nr2r": 19},
    },
    addition20to100: {
        type: 'TYPE_ADDITION',
        icon: '+',
        numberGenerator: {"type": "scale", "name": "20to100", "nr1": 20, "nr2": 100, "nr1r": 30, "nr2r": 10, "nr3r": 1}
    },
    subtraction1to20: {
        type: 'TYPE_SUBTRACTION',
        icon: '-',
        numberGenerator: {"type": "scale", "name": "1to20", "nr1": 1, "nr2": 20, "nr1r": 2, "nr2r": 1, "nr3r": 1},
    },
    multiply1to100: {
        type: 'TYPE_MULTIPLICATION',
        icon: 'x',
        numberGenerator: {"type": "scale", "name": "1to10", "nr1": 1, "nr2": 10},
    },
    subtraction20to100: {
        type: 'TYPE_SUBTRACTION',
        icon: '-',
        numberGenerator: {"type": "scale", "name": "20to100", "nr1": 20, "nr2": 100, "nr1r": 30, "nr2r": 10, "nr3r": 1}
    }
};
